import axios from '../axios';

const endpoints = {
  getListCentcoin: () => axios.get('/centcoin-list'),
  saveCentcoinApply: (data: any) => axios.post('centcoin/apply', data),
};

export default endpoints;
